"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HELP_LINKS_PROP_TYPE = exports.COUNTRIES_ARRAY_PROP_TYPE = exports.LINKS_DATA_SHAPE_PROP_TYPE = exports.LOCALE_INFO_SHAPE_PROP_TYPE = exports.LOCALES_ARRAY_PROP_TYPE = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOCALES_ARRAY_PROP_TYPE = _propTypes.default.arrayOf(_propTypes.default.shape({
  locale: _propTypes.default.string.isRequired,
  locale_name: _propTypes.default.string.isRequired
}));

exports.LOCALES_ARRAY_PROP_TYPE = LOCALES_ARRAY_PROP_TYPE;

var LOCALE_INFO_SHAPE_PROP_TYPE = _propTypes.default.shape({
  tld: _propTypes.default.string.isRequired,
  locale: _propTypes.default.string.isRequired,
  locale_name: _propTypes.default.string.isRequired,
  contact_us_path: _propTypes.default.string.isRequired,
  contact_us_url: _propTypes.default.string.isRequired,
  sales_contact_landing_page: _propTypes.default.string.isRequired,
  sales_contact_link_text: _propTypes.default.string.isRequired,
  twitter_page: _propTypes.default.string.isRequired,
  facebook_page: _propTypes.default.string.isRequired,
  linked_in_page: _propTypes.default.string.isRequired,
  instagram_page: _propTypes.default.string.isRequired,
  blog_url: _propTypes.default.string.isRequired
});

exports.LOCALE_INFO_SHAPE_PROP_TYPE = LOCALE_INFO_SHAPE_PROP_TYPE;

var LINKS_DATA_SHAPE_PROP_TYPE = _propTypes.default.arrayOf(_propTypes.default.shape({
  pk: _propTypes.default.number.isRequired,
  link: _propTypes.default.string.isRequired,
  title: _propTypes.default.string.isRequired
}));

exports.LINKS_DATA_SHAPE_PROP_TYPE = LINKS_DATA_SHAPE_PROP_TYPE;

var COUNTRIES_ARRAY_PROP_TYPE = _propTypes.default.arrayOf(_propTypes.default.shape({
  locale: _propTypes.default.string.isRequired,
  tld: _propTypes.default.string.isRequired,
  locale_name: _propTypes.default.string.isRequired
}));

exports.COUNTRIES_ARRAY_PROP_TYPE = COUNTRIES_ARRAY_PROP_TYPE;

var HELP_LINKS_PROP_TYPE = _propTypes.default.shape({
  home: _propTypes.default.string.isRequired,
  impressum: _propTypes.default.string.isRequired,
  suggested: _propTypes.default.arrayOf(_propTypes.default.shape({
    url: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    gaLabel: _propTypes.default.string
  })).isRequired
});

exports.HELP_LINKS_PROP_TYPE = HELP_LINKS_PROP_TYPE;
//# sourceMappingURL=constants.js.map